module.exports = __webpack_public_path__ + "lend_icon.svg?979372604c438d6449f28ab6bf00a47b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/lend_icon.svg
// module id = 1146
// module chunks = 2